module.exports = __webpack_public_path__ + "img/lb_yqkc.5f949b50.svg";